import { MobileTab } from "@/pages/Admin/components/OrgManagement/types";

// ---- 상단 주의사항/삭제 모드 토글 + 모바일 탭 ----

interface OrgToolbarProps {
  deleteMode: boolean;
  onToggleDeleteMode: () => void;
  mobileTab: MobileTab;
  onChangeMobileTab: (tab: MobileTab) => void;
}

const OrgToolbar = ({
  deleteMode,
  onToggleDeleteMode,
  mobileTab,
  onChangeMobileTab,
}: OrgToolbarProps) => {
  return (
    <>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex-1 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-small leading-relaxed text-amber-800">
          <p className="font-bold">* 주의사항</p>
          <p className="mt-1">
            공동체, 다락방, 순을 임의로 삭제하거나 수정할 경우, 소속 회원 및
            예약 데이터가 손상될 수 있습니다.
          </p>
          <p>전반적인 수정이 필요하시다면 시스템 관리자에게 문의해주세요.</p>
          <p className="mt-1">
            삭제 기능은 우측의 '삭제 모드' 버튼을 활성화한 후 사용할 수
            있습니다.
          </p>
        </div>
        <button
          type="button"
          onClick={onToggleDeleteMode}
          className={`shrink-0 rounded-lg border px-4 py-2 text-xs font-medium transition-all ${
            deleteMode
              ? "border-red-300 bg-red-50 text-red-600"
              : "border-gray-200 bg-white text-gray-400 hover:border-gray-300"
          }`}
        >
          {deleteMode ? "삭제 모드 ON" : "삭제 모드 OFF"}
        </button>
      </div>
      {/* 모바일: 탭 전환 */}
      <div className="flex gap-1 rounded-lg border border-gray-200 bg-gray-50 p-1 md:hidden">
        {(["cmt", "gar", "leaf"] as const).map(tab => (
          <button
            key={tab}
            type="button"
            onClick={() => onChangeMobileTab(tab)}
            className={`flex-1 rounded-md px-2 py-2 text-xs font-medium transition-colors ${
              mobileTab === tab
                ? "bg-primary text-white shadow-sm"
                : "text-gray-500 hover:bg-gray-100"
            }`}
          >
            {tab === "cmt" ? "공동체" : tab === "gar" ? "다락방" : "순"}
          </button>
        ))}
      </div>
    </>
  );
};

export default OrgToolbar;
